export default __webpack_public_path__ + "static/media/set-short-2.55dd9493.png";